<template>
    <div>
        <rkm-area background-color="primary" title="Antropometria" type="box">
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.peso"
                        append="kg"
                        label="Peso"
                        placeholder="000,00"
                        v-mask="pesoMask"
                        v-model="model.medicoes.peso"
                        @change="calcularImc(); handlePesoChange()"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.altura"
                        append="cm"
                        label="Altura"
                        placeholder="000,0"
                        v-mask="masks.altura"
                        v-model="model.medicoes.altura"
                        @change="calcularImc(); handleAlturaChange()"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        disabled
                        label="IMC"
                        v-model="imc.imc"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                kg/m²
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.perimetroCefalico"
                        append="cm"
                        label="Perímetro cefálico"
                        placeholder="000.0"
                        v-mask="masks.perimetroCefalico"
                        v-model="model.medicoes.perimetroCefalico"
                        @change="handleAntropometriaChange"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.circunferenciaAbdominal"
                        append="cm"
                        label="Circunferência abdominal"
                        placeholder="000,0"
                        v-mask="masks.circunferenciaAbdominal"
                        v-model="model.medicoes.circunferenciaAbdominal"
                        @change="handleAntropometriaChange"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.perimetroPanturrilha"
                        append="cm"
                        label="Perímetro da panturrilha"
                        placeholder="00,0"
                        v-mask="masks.perimetroPanturrilha"
                        v-model="model.medicoes.perimetroPanturrilha"
                        @change="handleAntropometriaChange"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area background-color="primary" title="Sinais Vitais" type="box">
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.pressaoArterial"
                        label="Pressão arterial"
                        placeholder="000/000"
                        v-mask="'###/###'"
                        v-model="model.medicoes.pressaoArterial"
                        @change="handlePressaoArterialChange"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                mmHg
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.frequenciaRespiratoria"
                        label="Frequência respiratória"
                        placeholder="000"
                        v-mask="'###'"
                        v-model="model.medicoes.frequenciaRespiratoria"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                mpm
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.frequenciaCardiaca"
                        label="Frequência cardíaca"
                        placeholder="000"
                        v-mask="'###'"
                        v-model="model.medicoes.frequenciaCardiaca"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                bpm
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.temperatura"
                        label="Temperatura"
                        placeholder="00,0"
                        v-mask="'##.#'"
                        v-model="model.medicoes.temperatura"
                        @change="handleTemperaturaChange"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                °C
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.saturacaoO2"
                        label="Saturação de O2"
                        placeholder="000"
                        v-mask="'###'"
                        v-model="model.medicoes.saturacaoO2"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                %
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.glicemia"
                        label="Glicemia capilar"
                        placeholder="000"
                        v-mask="masks.glicemia"
                        v-model="model.medicoes.glicemia"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                mg/dL
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.momentosColeta"
                        :validations="validations.momentoColeta"
                        default-option-text="Selecione"
                        label="Momento da coleta"
                        show-default-option
                        text-field="nome"
                        v-model="model.medicoes.momentoColetaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
// Enums.
import procedimento from '@/enums/sigtap/procedimento'
import unidadeMedida from '@/enums/cadastro/unidadeMedida'

// Mixins.
import {error, mask, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                peso: {min_value: 0.5, max_value: 500},
                altura: {min_value: 20, max_value: 250},
                perimetroCefalico: {min_value: 10, max_value: 200},
                circunferenciaAbdominal: {max_value: 999},
                perimetroPanturrilha: {min_value: 10, max_value: 99},
                pressaoArterial: {},
                frequenciaRespiratoria: {min_value: 0, max_value: 200},
                frequenciaCardiaca: {max_value: 999},
                temperatura: {min_value: 20, max_value: 45},
                saturacaoO2: {min_value: 0, max_value: 100},
                glicemia: {required: !!this.model.medicoes.momentoColetaId, min_value: 0, max_value: 800},
                momentoColeta: {required: !!this.model.medicoes.glicemia},
            }
        },
        pesoMask() {
            const length = (this.model.medicoes.peso ?? '').replace(',', '').length

            if (length <= 3) {
                return '#,##'
            }
            else if (length <= 4) {
                return '##,##'
            }

            return '###,##'
        },
    },
    data: () => ({
        enums: {procedimento, unidadeMedida},
        imc: {
            imc: null,
            classificacao: null,
        },
        masks: {
            altura: '###,#',
            circunferenciaAbdominal: '###,#',
            glicemia: '###',
            perimetroCefalico: '###.#',
            perimetroPanturrilha: '##,#',
        },
    }),
    created() {
        this.repositories = {
            geral: this.getConectaSusRepository('geral'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }

        this.calcularImc()
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        temAlgumaAntropometria() {
            const medicoes = this.model.medicoes

            return !!(medicoes.peso || medicoes.altura || medicoes.perimetroCefalico || medicoes.circunferenciaAbdominal || medicoes.perimetroPanturrilha)
        },
        hasProcedimentoClinico(codigo) {
            return this.model.procedimentosClinicos.some(procedimentoClinico => procedimentoClinico.procedimento.codigo === codigo)
        },
        insertProcedimentoClinico(codigo) {
            if (this.hasProcedimentoClinico(codigo)) return

            this.repositories.procedimento.index({codigo})
                .then(({data}) => {
                    const procedimentoEncontrado = data[0]

                    if (!procedimentoEncontrado || this.hasProcedimentoClinico(codigo)) return

                    this.model.procedimentosClinicos.push({
                        procedimento: {
                            id: procedimentoEncontrado.id,
                            codigo: procedimentoEncontrado.codigo,
                            nome: procedimentoEncontrado.nome,
                            hasCidPrincipal: procedimentoEncontrado.hasCidPrincipal,
                        },
                        cid: null,
                        quantidade: 1,
                        observacao: null,
                    })
                })
                .catch(this.handleError)
        },
        deleteProcedimentoClinico(codigo) {
            const index = this.model.procedimentosClinicos.findIndex(procedimentoClinico => procedimentoClinico.procedimento.codigo === codigo)

            if (index !== -1) {
                this.model.procedimentosClinicos.splice(index, 1)
            }
        },
        handlePesoChange() {
            if (this.model.medicoes.peso) {
                this.insertProcedimentoClinico(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                this.insertProcedimentoClinico(this.enums.procedimento.MEDICAO_DE_PESO)
            } else {
                if (!this.temAlgumaAntropometria()) {
                    this.deleteProcedimentoClinico(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                this.deleteProcedimentoClinico(this.enums.procedimento.MEDICAO_DE_PESO)
            }
        },
        handleAlturaChange() {
            if (this.model.medicoes.altura) {
                this.insertProcedimentoClinico(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                this.insertProcedimentoClinico(this.enums.procedimento.MEDICAO_DE_ALTURA)
            } else {
                if (!this.temAlgumaAntropometria()) {
                    this.deleteProcedimentoClinico(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                this.deleteProcedimentoClinico(this.enums.procedimento.MEDICAO_DE_ALTURA)
            }
        },
        handleAntropometriaChange() {
            if (this.temAlgumaAntropometria()) {
                this.insertProcedimentoClinico(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
            } else {
                this.deleteProcedimentoClinico(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
            }
        },
        handlePressaoArterialChange() {
            if (this.model.medicoes.pressaoArterial) {
                this.insertProcedimentoClinico(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {
                this.deleteProcedimentoClinico(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            }
        },
        handleTemperaturaChange() {
            if (this.model.medicoes.temperatura) {
                this.insertProcedimentoClinico(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            } else {
                this.deleteProcedimentoClinico(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            }
        },
        calcularImc() {
            if (!this.model.medicoes.peso || !this.model.medicoes.altura) {
                this.imc.imc = null
                this.imc.classificacao = null

                return
            }

            this.setLoading()

            const request = {
                unidadeMedidaMassaId: this.enums.unidadeMedida.QUILOGRAMAS,
                massa: this.model.medicoes.peso.replace(',', '.'),
                unidadeMedidaAlturaId: this.enums.unidadeMedida.CENTIMETROS,
                altura: this.model.medicoes.altura.replace(',', '.'),
            }

            this.repositories.geral.calcularIMC(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.imc = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, mask, repository, stringCase],
    props: {
        model: {type: Object, required: true},
        form: {type: Object, required: true},
    },
}
</script>
